
import { useEffect, useRef } from "react";
import { useAdminArticles } from "@/hooks/admin/useAdminArticles";
import { useAdminFaqs } from "@/hooks/admin/useAdminFaqs";

export const useContentManagement = (userRole: string | null) => {
  // Articles and authors management
  const {
    articles,
    tags: articleTags,
    authors: articleAuthors,
    loading: articlesLoading,
    loadArticles,
    loadTags: loadArticleTags,
    loadAuthors: loadArticleAuthors,
    createArticle,
    updateArticle,
    deleteArticle,
    createTag: createArticleTag,
    uploadMediaToStorage: uploadArticleMedia,
    fetchMedia,
    updateMediaMetadata,
    deleteMedia,
    createAuthor,
    updateAuthor,
    deleteAuthor,
    fetchArticleById
  } = useAdminArticles();
  
  // FAQs management
  const {
    faqs,
    loading: faqsLoading,
    loadFaqs,
    createFaq,
    updateFaq,
    deleteFaq
  } = useAdminFaqs();
  
  // Track if articles have been pre-loaded
  const articlesLoadedRef = useRef(false);
  
  // Pre-load articles data only once when admin context is initialized
  useEffect(() => {
    if ((userRole === 'admin' || userRole === 'editor') && !articlesLoading && (!articles || articles.length === 0) && !articlesLoadedRef.current) {
      console.log("Pre-loading articles data in admin context");
      loadArticles();
      loadArticleTags();
      loadArticleAuthors();
      articlesLoadedRef.current = true;
    }
  }, [userRole, articlesLoading, articles, loadArticles, loadArticleTags, loadArticleAuthors]);

  return {
    articles,
    articleTags,
    articleAuthors,
    articlesLoading,
    faqs,
    faqsLoading,
    
    // Articles related methods
    loadArticles,
    loadArticleTags,
    loadArticleAuthors,
    createArticle,
    updateArticle,
    deleteArticle,
    createArticleTag,
    uploadArticleMedia,
    fetchArticleById,
    fetchMedia,
    updateMediaMetadata,
    deleteMedia,
    
    // Authors related methods
    createAuthor,
    updateAuthor,
    deleteAuthor,
    
    // FAQs related methods
    loadFaqs,
    createFaq,
    updateFaq,
    deleteFaq
  };
};
